
<ng-container>
    <div class="row">
        <div class="col-6">
            <tsl-label i18n="@@AdditionalTaxId" t="AdditionalTaxId" class="w-50 paddingLeftMore">Additional Tax ID Types</tsl-label>
            <tsl-icon tslSuffix size="medium" class="add-icon paddingLeft" tslTooltip="Add New Tax Id Type" *ngIf="showAddComponent" (click)="AddComponent()">add_circle_outline</tsl-icon>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="w-100">
                <form [formGroup]="taxIdTypeForm">
                    <ng-template #taxIdContainerRef></ng-template>
                </form>
            </div>
        </div>
    </div>
</ng-container>